var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#F25112"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.872 23.7236H25.128C21.1913 23.7236 18 26.9149 18 30.8516V89.1356C18 93.0723 21.1913 96.2636 25.128 96.2636H94.872C98.8087 96.2636 102 93.0723 102 89.1356V30.8516C102 26.9149 98.8087 23.7236 94.872 23.7236Z",
    fill: "#FFF0EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9078 37.7278C85.7178 37.7278 87.9958 35.4498 87.9958 32.6398C87.9958 29.8297 85.7178 27.5518 82.9078 27.5518C80.0978 27.5518 77.8198 29.8297 77.8198 32.6398C77.8198 35.4498 80.0978 37.7278 82.9078 37.7278Z",
    fill: "#FF8C5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0919 37.7278C39.9019 37.7278 42.1799 35.4498 42.1799 32.6398C42.1799 29.8297 39.9019 27.5518 37.0919 27.5518C34.2819 27.5518 32.0039 29.8297 32.0039 32.6398C32.0039 35.4498 34.2819 37.7278 37.0919 37.7278Z",
    fill: "#FF8C5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8199 47.9043H23.0879V60.6363H35.8199V47.9043Z",
    fill: "#6A37BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0958 47.9043H38.3638V60.6363H51.0958V47.9043Z",
    fill: "#32DBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3721 47.9043H53.6401V60.6363H66.3721V47.9043Z",
    fill: "#35B94E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9122 47.9043H84.1802V60.6363H96.9122V47.9043Z",
    fill: "#FFE333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8199 63.1797H23.0879V75.9117H35.8199V63.1797Z",
    fill: "#F25112"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3721 63.1797H53.6401V75.9117H66.3721V63.1797Z",
    fill: "#E81111"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6358 63.1797H68.9038V75.9117H81.6358V63.1797Z",
    fill: "#116EEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9122 63.1797H84.1802V75.9117H96.9122V63.1797Z",
    fill: "#6A37BC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8199 78.4561H23.0879V91.1881H35.8199V78.4561Z",
    fill: "#32DBDB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0958 78.4561H38.3638V91.1881H51.0958V78.4561Z",
    fill: "#35B94E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3721 78.4561H53.6401V91.1881H66.3721V78.4561Z",
    fill: "#FFE333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6358 78.4561H68.9038V91.1881H81.6358V78.4561Z",
    fill: "#F25112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/Activities.4fe3f86a1516a0f15fe3d9992e41aba3.svg";
export { ForwardRef as ReactComponent };